import TextArea, { TextareaProps } from './textarea';

export type { TextareaProps };
export default TextArea;
